module.exports = __webpack_public_path__ + "e8fd5af204e5b4c36121da794bee6fab.jpg";